export default function HomeSection({ toggle, breadcrumb }) {
  return (
    <>
      <section
        className={
          toggle
            ? `home befor-elm margin-right-z`
            : `home t-page margin-right-z mt-5`
        }
        id="home"
      >
        {toggle ? (
          <>
            <div className="content margin-right-z">
              <h1>هوش جدید ، راهی به سوی زندگی جدید</h1>
              <p>در سایت هوش جدید، ما سه نوع خدمات حرفه‌ای ارائه می‌دهیم:</p>
              <br />

              <ol>
                <li>خدمات برنامه نویسی</li>
                <li>خدمات آموزشی</li>
                <li>خدمات گرافیکی</li>
              </ol>
              <ol>
                <li>
                  طراحی سایت و برنامه‌نویسی: تیم ما با تجربه و تخصص خود،
                  وب‌سایت‌های زیبا و کارآمدی طراحی می‌کند که به نیازهای شما پاسخ
                  می‌دهد.
                </li>
                <li>
                  آموزش زبان‌های برنامه‌نویسی: ما دوره‌های آموزشی ساده و کاربردی
                  در زبان‌های برنامه‌نویسی PHP، Python و JavaScript داریم. این
                  دوره‌ها به شما کمک می‌کنند تا از پایه تا پیشرفته، مهارت‌های
                  لازم را یاد بگیرید.
                </li>
                <li>
                  آموزش کاربرد هوش مصنوعی: با دوره‌های ما، می‌توانید با مفاهیم
                  هوش مصنوعی آشنا شوید و یاد بگیرید چگونه از این فناوری در
                  پروژه‌های خود استفاده کنید.
                </li>
                <li>
                  خدمات گرافیکی ما شامل طراحی انواع لوگو و موشن گرافیک و تیزرهای
                  تبلیغاتی برای شبکه های اجتماعی است
                </li>
                <li>
                  تیم ما آماده است تا با مشاوره‌های حرفه‌ای، شما را در هر مرحله
                  از یادگیری و توسعه همراهی کند. به ما بپیوندید و آینده‌ای روشن
                  و هوشمندانه بسازید!
                </li>
              </ol>
            </div>

            <div className="box-container">
              <div className="box">
                <i className="fas fa-graduation-cap"></i>
                <h3>تدریس تیم ما</h3>
                <p>
                  تدریس دوره‌های برنامه‌نویسی: PHP , Javascript , Python , ai,
                  WordPress (آنلاین و حضوری)
                </p>
              </div>

              <div className="box">
                <i className="fas fa-fire"></i>
                <h3>تجربه</h3>
                <p>15 سال تجربه برنامه نویسی</p>
              </div>

              <div className="box">
                <i className="fas fa-award"></i>
                <h3>دستاورد ها</h3>
                <p>
                  مدیر و صاحب امتیاز چندین فروشگاه آنلاین با ۷ سال تجربه رسمی
                </p>
              </div>
            </div>

            <div className="p-count">
          <h2>چرا وردپرس؟</h2>
          <p className="p-section">
            وردپرس، به عنوان یکی از معروف‌ترین و پرکاربردترین سیستم‌های مدیریت
            محتوا در جهان و به‌ویژه در ایران، تقریباً نیمی از سهم بازار جهانی را
            در اختیار دارد.
            <br />
            یکی از مهم‌ترین مزایای وردپرس، سادگی و روانی در یادگیری و مدیریت آن
            است، به‌طوری که نیازی به دانش برنامه‌نویسی خاصی ندارد.
            <br />
            همچنین، وجود مارکت‌های متنوع ایرانی و خارجی، این امکان را فراهم
            می‌آورد که ابزارهای لازم برای رفع نیازهای عمومی یک سایت به راحتی در
            دسترس باشد.
            <br />
            جامعه فعال برنامه‌نویسان و توسعه‌دهندگان نیز آماده‌اند تا نیازهای
            اختصاصی شما را برآورده کنند.
            <br />
            علاوه بر این، برای نگهداری و پشتیبانی سایت و کسب‌وکار شما، نیروی کار
            زیادی در دسترس است، بنابراین نگرانی از بابت استخدام کارمند برای
            مدیریت سایت خود نخواهید داشت.
          </p>

          <h2>چگونه می‌توان صاحب یک وب‌سایت وردپرسی شد؟</h2>
          <p className="p-section">
            این سؤال بسیار خوبی است! برای راه‌اندازی یک وب‌سایت وردپرسی، دو
            گزینه اصلی دارید:
            <br />
            ۱. برون‌سپاری کار به شرکت‌های برنامه‌نویسی که این کار را برای شما
            انجام می‌دهند.
            <br />
            ۲. راه‌اندازی سایت به‌صورت مستقل و شخصی.
            <br />
            هر یک از این روش‌ها مزایا و معایب خاص خود را دارند.
            <br />
            اگر کار طراحی سایت را برون‌سپاری کنید، ممکن است با هزینه‌های متغیر
            طراحی مواجه شوید و نگرانی‌هایی درباره محرمانگی اطلاعات شما نیز وجود
            داشته باشد. همچنین، اعمال تغییرات و به‌روزرسانی‌ها ممکن است زمان‌بر
            باشد زیرا شما به شرکت خارجی وابسته هستید.
            <br />
            با این حال، این روش به شما این امکان را می‌دهد که با خیالی آسوده به
            سایر جنبه‌های کسب‌وکار خود بپردازید.
            <br />
            از طرف دیگر، اگر خودتان وب‌سایت را طراحی کنید، قادر خواهید بود به
            سرعت تغییرات را اعمال کرده و با تمرکز بیشتری به تولید محتوا
            بپردازید.
          </p>

          <h2>چگونه می‌توانیم آموزش وردپرس را یاد بگیریم؟</h2>
          <p className="p-section">
            یادگیری وردپرس دو مزیت اصلی دارد:
            <br />
            ۱. شما می‌توانید به‌طور مستقل وب‌سایت خود را راه‌اندازی کنید و از آن
            بهره‌برداری نمایید.
            <br />
            ۲. با یادگیری وردپرس، می‌توانید به‌عنوان یک نیروی کار در شرکت‌ها و
            کسب‌وکارهایی که به نیروهای متخصص وردپرس نیاز دارند، استخدام شوید.
          </p>

          <h2>چرا دوره‌های آموزشی وردپرس ما را انتخاب کنید؟</h2>
          <p className="p-section">
            دوره‌های آموزشی وردپرس ما به‌صورت جامع و کاربردی طراحی شده‌اند تا
            شما را در کمترین زمان ممکن به یک متخصص وردپرس تبدیل کنند. با یادگیری
            از بهترین مدرسان و استفاده از منابع معتبر، شما می‌توانید به راحتی
            وب‌سایت خود را طراحی و مدیریت کنید. همچنین، با گذراندن این دوره‌ها،
            فرصت‌های شغلی متعددی در انتظار شما خواهد بود.
            <br />
            به جمع کاربران موفق وردپرس بپیوندید و با ما همراه شوید!
            <br />
            برای مشاهده تمامی دوره‌ها به{" "}
            <a
              href="https://hooshjadid.ir/courses"
              target="_blank"
              rel="noopener noreferrer"
            >
              این لینک
            </a>{" "}
            مراجعه کنید.
            <br />
            همچنین، برای خرید دوره مستر پلاس وردپرس، به{" "}
            <a
              href="https://hooshjadid.ir/dashboard/payment/2"
              target="_blank"
              rel="noopener noreferrer"
            >
              این لینک
            </a>{" "}
            مراجعه نمایید.
          </p>
        </div>           
          </>
        ) : (
          <div className="content t-page-c margin-right-z">
            <h1>{breadcrumb}</h1>
            <nav className="breadcrumb">
              <ul>
                <li>
                  <a href="#">صفحه اصلی</a>
                </li>
                <li> / </li>
                <li>
                  <a href="#">{breadcrumb}</a>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </section>      
    </>
  );
}
